import { wordService } from "../services/wordService";

export const applyHeading5 = () =>
  wordService.applySemanticTag({ type: "section", styleBuiltIn: "Heading5", metadata: { level: 5 } });
